import { createSelector } from 'reselect';
import Immutable from 'immutable';

const interlibraryLoansStatus = state => state.getIn(['borrowing', 'interlibraryLoans'], Immutable.Map());
const interlibraryLoans = state => state.getIn(['entities', 'interlibraryLoans'], Immutable.Map());

export const getInterlibaryLoansStatus = createSelector(
  [interlibraryLoansStatus],
  (status) => status
);

export const getInterlibaryLoans = createSelector([interlibraryLoans], (loans) => loans);


export default {
  getInterlibaryLoansStatus,
  getInterlibaryLoans
};



// WEBPACK FOOTER //
// ./app/selectors/InterlibraryLoansSelector.js